import React, { useState } from 'react';
import styled from 'styled-components';

import { InputField } from '../../../../healtheraComponents';

const KeywordInput = ({ onSubmit, ...props }) => {
  const [keyword, setKeyword] = useState('');

  const eventHandler = e => {
    switch (e.type) {
      case 'change':
        const { value } = e.target;
        setKeyword(value);
        break;
      case 'blur':
      case 'submit':
        e.preventDefault();
        setKeyword('');
        onSubmit(
          keyword
            .split(',')
            .map(keyword => keyword.trim())
            .filter(Boolean)
        );
        break;
      default:
        break;
    }
  };

  return (
    <Form onSubmit={eventHandler}>
      <InputField
        margintop="0"
        onBlur={eventHandler}
        onChange={eventHandler}
        value={keyword}
        {...props}
      />
    </Form>
  );
};

const Form = styled.form`
  width: 100%;
`;

export default KeywordInput;
